import { Index, type JSX } from 'solid-js';
import { Skeleton } from './Skeleton';

// Loading placeholder for the card-grid routes (repos, keys). Renders `count`
// skeleton cards into the route's own grid class so the layout doesn't jump when
// real data swaps in. `Index` over a fixed-length array — static, no keys needed.

export type CardGridSkeletonProps = {
  /** The route's grid class, e.g. `repos__grid` / `account-keys__list`. */
  readonly listClass: string;
  readonly count?: number;
};

export function CardGridSkeleton(props: CardGridSkeletonProps): JSX.Element {
  return (
    <ul class={props.listClass} aria-hidden="true">
      <Index each={Array.from({ length: props.count ?? 3 })}>
        {() => (
          <li>
            <Skeleton class="skeleton--card" />
          </li>
        )}
      </Index>
    </ul>
  );
}
